export const DATA_VERSION = '1792399621';
